import { TitleXS } from "@components/Typography"
import { breakpoints, theme } from "@config/theme"
import styled from "styled-components"

export const ImgWrapper = styled.div`
  width: 4.5rem;
  height: 4.5rem;
  background: ${theme.colors.card.default};

  img {
    max-width: 100%;
  }
`

export const Title = styled(TitleXS)`
  margin: 0;
  margin-bottom: 0.25rem;
  text-decoration: none;
  color: #000;
  font-family: ${(p) => p.theme.fonts.serif};

  @media (max-width: ${breakpoints.small}) {
    font-size: 1rem;
  }
`

export const Anchor = styled.div`
  display: grid;
  grid-template-columns: 4.5rem 1fr;
  grid-gap: 1rem;
  width: 100%;
  cursor: pointer;
  margin-bottom: 1rem;
`

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`
